module.exports = __webpack_public_path__ + "static/img/about1.c1e9d247.png";